import { materialityLensSelectionState } from '@upright/ui/common/upright/core/impact-lenses/materiality/selection-state';
import { materialityLensTexts } from '@upright/ui/common/upright/core/impact-lenses/materiality/texts';
import {
  MaterialityLensData,
  MaterialityLensOptions,
} from '@upright/ui/common/upright/core/impact-lenses/materiality/types';
import { ImpactLens } from '@upright/ui/common/upright/core/impact-lenses/types';
import { ImpactLensType } from '@upright/common/impact-lenses/types';

export const materialityLens: ImpactLens<ImpactLensType.CSRD, MaterialityLensData, MaterialityLensOptions> = {
  type: ImpactLensType.CSRD,
  ImpactDataComponent: { component: () => <></> },
  infoBoxes: {},
  ...materialityLensSelectionState,
  ...materialityLensTexts,
};
